/** A horizontal Flexbox */

import { Box, styled } from '@mui/material'

export const HBox: typeof Box = styled(Box)(({}) => ({
  display: 'flex',
  flexDirection: 'row',
})) as never
